<h1 class="text-white text-lg font-semibold">Pruebas</h1>